export default __webpack_public_path__ + "static/media/Spiritual.74d94739.svg";